import { useEffect, useState, useRef, useCallback } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Select from 'react-select';
import Lottie from "lottie-react";

import { usePageMetadata } from '../../hooks/usePageMetadata';
import styles from "./Contact.module.css"
import homemods_logo_nb from "../../assets/images/homemods_logo_nb.svg";
import mylo_home_banner from "../../assets/images/mylo_home_banner.svg";
import mylo_home_banner_short from "../../assets/images/mylo_home_banner_short.svg";

import logo from "../../assets/images/logo.svg";
import ndis_logo from "../../assets/images/ndis_logo.svg";
import smoke_alarm from "../../assets/images/smoke_alarm.jpg";
import cloud1 from "../../assets/images/cloud1.svg";
import cloud2 from "../../assets/images/cloud2.svg";
import cloud3 from "../../assets/images/cloud3.svg";
import car1 from "../../assets/images/car1.svg";
import car2 from "../../assets/images/car2.svg";
import myloAnimation from "../../assets/images/mylo_animation.json";

import initializeMapWithAccessToken from '../Utils/InitMap';
import Footer from "../Footer"
import Topbar from "../Topbar"


const Banner = () => {
	return (
		<div className={styles.banner_container}>
			<div className={styles.banner_inner_container}>
				<div className={styles.banner_inner}>
					<img src={logo}/>

					<div className={styles.banner_heading}>
						<h1 className={`xl3 forma bold ${styles.optimised}`}>Australian Family Owned & Run. Local Trademan. Competitive Prices.</h1>
						<h1 className={`xxxxxxl3 forma bold ${styles.non_optimised}`}>Australian Family Owned & Run. Local Trademan. Competitive Prices.</h1>

						<a className={`${styles.banner_button} ${styles.non_optimised}`} href={"tel:+136956"}>
							<p className={`xl1 inter medium`}>13 MYLO (13 69 56)</p>
							<i className="fa-solid fa-phone xl2"></i>
						</a>
					</div>
				</div>

				<div className={styles.transition_container} style={{ bottom: '-80px' }}>
					<div className={styles.transition_effect_1} style={{ bottom: '50px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#fdde42" }}/>
					<div className={styles.transition_effect_2} style={{ bottom: '20px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#fdde42" }}/>
					<div className={styles.transition_effect_3} style={{ bottom: '-10px', borderBottomLeftRadius: '30px', borderBottomRightRadius: '30px', background: "#fdde42" }}/>
				</div>
			</div>
		</div>
	)
}

const ContactUsBoxes = () => {
	return (
		<div className={styles.contactus_box_container}>
			<div className={styles.contactus_box}>
				<i className="fa-solid fa-phone xxl3"></i>
				<p className={`xl3 forma bold ${styles.cmessage_banner}`}>Talk to a member of our Sales team</p>
				<p className={`m2 inter light`}>We'll help you find the right services and pricing for your home or business</p>

				<a className={styles.contactus_box_btn} href={"tel:+136956"}>
					<p className={`m3 inter medium`}>Call MYLO</p>
				</a>
			</div>

			<div className={styles.contactus_box}>
				<i className="fa-solid fa-envelope xxl3"></i>
				<p className={`xl3 forma bold ${styles.cmessage_banner}`}>Service and account support</p>
				<p className={`m2 inter light`}>If you can't find the answer you're looking for, we're here to lend a hand.</p>

				<a className={styles.contactus_box_btn} href={"mailto:office@mylo.com.au"}>
					<p className={`m3 inter medium`}>Email MYLO</p>
				</a>
			</div>
		</div>
	)
}

const HouseBanner = () => {
  	const refs = {
    	car1: useRef(null),
    	car2: useRef(null),
    	cloud1: useRef(null),
    	cloud2: useRef(null),
    	cloud3: useRef(null),

    	car1opt: useRef(null),
    	cloud1opt: useRef(null)
  	};

  	const config = [
    	{ key: "car1", speed: 0.3, dir: 1 },
    	{ key: "car2", speed: 0.3, dir: -1 },
    	{ key: "cloud1", speed: 0.2, dir: 1 },
    	{ key: "cloud2", speed: 0.2, dir: -1 },
    	{ key: "cloud3", speed: 0.2, dir: -1 },

    	{ key: "car1opt", speed: 0.025, dir: 1 },
    	{ key: "cloud1opt", speed: 0.025, dir: -1 }
  	];

  	const targetXs = useRef(config.map(() => 0));
  	const currentXs = useRef(config.map(() => 0));

  	useEffect(() => {
    	const handleScroll = () => {
      		const y = window.scrollY;
      		config.forEach((c, i) => {
        		targetXs.current[i] = y * c.speed;
      		});
    	};

    	window.addEventListener("scroll", handleScroll, { passive: true });

    	let rafId;
    	const animate = () => {
      		config.forEach((c, i) => {
        		const el = refs[c.key].current;
        		if (!el) return;
        		currentXs.current[i] += (targetXs.current[i] - currentXs.current[i]) * 0.1;
        		el.style.transform = `translateX(${currentXs.current[i] * c.dir}px)`;
      		});

      		rafId = requestAnimationFrame(animate);
    	};

    	rafId = requestAnimationFrame(animate);

    	return () => {
      		window.removeEventListener("scroll", handleScroll);
      		cancelAnimationFrame(rafId);
    	};
  	}, []);


	return (
		<div className={styles.house_banner_container}>
			<img src={mylo_home_banner} className={`${styles.car_banner} ${styles.non_optimised}`}/>
			<img src={car1} className={`${styles.car1} ${styles.non_optimised}`} ref={refs.car1}/>
			<img src={car2} className={`${styles.car2} ${styles.non_optimised}`} ref={refs.car2}/>
			<img src={cloud1} className={`${styles.cloud1} ${styles.non_optimised}`} ref={refs.cloud1}/>
			<img src={cloud2} className={`${styles.cloud2} ${styles.non_optimised}`} ref={refs.cloud2}/>
			<img src={cloud3} className={`${styles.cloud3} ${styles.non_optimised}`} ref={refs.cloud3}/>

			<img src={mylo_home_banner_short} className={`${styles.car_banner} ${styles.optimised}`}/>
			<img src={car1} className={`${styles.car1opt} ${styles.optimised}`} ref={refs.car1opt}/>
			<img src={cloud1} className={`${styles.cloud1opt} ${styles.optimised}`} ref={refs.cloud1opt}/>
		</div>
	)
}

const ContactUsModule = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [activeMap, setActiveMap] = useState("VIC")
	const [formData, setFormData] = useState({})
	const [validationError, setValidationError] = useState(null)
	const [validationArea, setValidationArea] = useState(null)
	const [successMsg, setSuccessMsg] = useState(null)
	const inputs = [
		{
			label: "First Name",
			key: "first_name",
			type: "input",
			required: true
		},
		{
			label: "Last Name",
			key: "last_name",
			type: "input",
			required: true
		},
		{
			label: "Email Address",
			key: "email",
			type: "input",
			required: true
		},
		{
			label: "Phone Number",
			key: "phone",
			type: "input"
		},
		{
			label: "State",
			key: "state",
			type: "select",
			options: ["VIC", "NSW"],
			required: true
		},
		{
			label: "Service",
			key: "service",
			type: "select",
			options: ["MYLO Safety", "MYLO Tradies", "MYLO Home Modifications"],
			required: true
		},
		{
			label: "Message",
			key: "message",
			type: "textarea",
			required: true
		},
	]

	useEffect(() => {
		const loadMap = async () => {
			await initializeMapWithAccessToken(activeMap)
		}

		loadMap()
	}, [activeMap]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;
    script.async = true;

    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (!validationError) return;

    const timerId = setTimeout(() => {
      setValidationError(null);
      setValidationArea(null);
    }, 7000);

    return () => clearTimeout(timerId);
  }, [validationError]);

  useEffect(() => {
    if (!successMsg) return;

    const timerId = setTimeout(() => {
      setSuccessMsg(null);
    }, 7000);

    return () => clearTimeout(timerId);
  }, [successMsg]);


	const handleMap = (state) => {
		setActiveMap(state)
	}

	const validateForm = () => {
		for (const input of inputs) {
			if (input.required) {
				if (!formData.hasOwnProperty(input.key) || !formData[input.key] || formData[input.key] === "") {
					setSuccessMsg(null)
					setValidationError(`Please ${input.type === "select" ? "select" : "enter"} a ${input.label.toLowerCase()}`)
					setValidationArea(input.key)

					return false;
				}
			}
		}

		setValidationError(null)
		setValidationArea(null)
		return true;
	}

	const handleForm = (type, name, input) => {
		const value = type === "select" ? input.value : input.target.value
		if ((validationArea && validationArea === name) && value !== "") {
			setValidationError(null)
			setValidationArea(null)
		}

		setFormData((prev) => ({ ...prev,
			[name]: value
		}))
	}

	const handleSubmit = async e => {
    e.preventDefault();
    if (!window.grecaptcha) {
      setValidationError("There was an error submitting this form");
    }

    const validation = validateForm();
    if (!validation) {
    	return;
    }

    setIsLoading(true)
    const token = await window.grecaptcha.execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, { action: 'contact_form' });
    const res = await fetch('https://myloportal.com.au/api/public/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: formData, token })
    });

    if (res && res.ok) {
    	setValidationError(null)
    	setValidationArea(null)
    	setFormData({})

    	setSuccessMsg("This form has been successfully submitted")
    } else {
    	setSuccessMsg(null)
    	setValidationError("This form failed to submit")
    }

    setIsLoading(false)
	}

	return (
		<div className={styles.contactus_module}>
			<div className={styles.contactus_box}>

	      <div className={styles.validation_error + (validationError ? ` ${styles.visible}` : '')}>
	        <p className={`m1 inter medium`}>{validationError}</p>
	      </div>

	      <div className={styles.success_msg + (successMsg ? ` ${styles.visible}` : '')}>
	        <p className={`m1 inter medium`}>{successMsg}</p>
	      </div>

				<p className={`xl3 forma bold ${styles.cmessage_banner}`}>Contact Us</p>
				<p className={`m2 inter light ${styles.contactus_bannertext}`}>For a reliable way to contact us, fill out the form below by telling us what you need<br/>and we'll get back to you as soon as we're able to.</p>

				{!isLoading
					?
						<form onSubmit={handleSubmit} className={styles.outer_form}>
							<div className={styles.form_grid}>
								{inputs.map((input) => (
									<div className={`${input.type !== "textarea" ? styles.input_container : styles.textarea_container}`}>
										<p className={`s3 inter medium`}>{input.label}</p>
										{input.type === "input" &&
											<input
												className={`m1 inter light ${styles.contactus_input} ${(validationArea && validationArea === input.key) && styles.validation_area}`}
												onChange={(e) => handleForm(input.type, input.key, e)}
												value={formData[input.key]}
											/>
										}

										{input.type === "textarea" &&
											<textarea
												className={`m1 inter light ${styles.contactus_textarea} ${(validationArea && validationArea === input.key) && styles.validation_area}`}
												onChange={(e) => handleForm(input.type, input.key, e)}
												value={formData[input.key]}
											></textarea>
										}

										{input.type === "select" &&
				              <Select
				                options={input.options.map(opt => ({ label: opt, value: opt }))}
				                className={'s3 inter medium'}
				                styles={{
											    control: (base, { isFocused }) => {
											      const border = (validationArea && validationArea === input.key)
											      	? '3px solid red'
											      	: isFocused
											        ? '3px solid var(--mylo-yellow)'
											        : '3px solid var(--white)';

											      return {
											        ...base,
											        borderRadius: '5px',
											        padding: '2.5px 0',
											        marginTop: '2.5px',
											        boxShadow: 'none',
											        background: 'var(--white)',
											        border,
											        '&:hover': {
											          border,
											          boxShadow: 'none',
											        },
											      };
											    },

				                  option: (provided, state) => ({
				                    ...provided,
				                    backgroundColor: state.isSelected ? 'var(--mylo-yellow)' : 'var(--white)',
				                    color: state.isSelected ? 'var(--white)' : 'var(--black)',
				                    padding: '12.5px',
				                    fontSize: '16px',
				                    '&:hover': {
				                      cursor: 'pointer',
				                      color: '#ffffff',
				                      backgroundColor: 'var(--mylo-yellow) !important'
				                    }
				                  }),
				                }}
				                onChange={(e) => handleForm(input.type, input.key, e)}
				                value={formData && {value: formData[input.key], label: formData[input.key]}}
				              />
										}
									</div>
								))}
							</div>

							<button disabled={isLoading} className={`${styles.contactus_submit}`} type="submit">
								<p className={`m1 inter medium`}>Submit</p>
							</button>
						</form>
					:
						<div className={styles.loading_container}>
							<Lottie animationData={myloAnimation} loop={true} style={{width: "75%", height: "75%"}}/>
						</div>

				}
			</div>


			<div className={styles.contactus_box_nbg}>
				<p className={`m2 inter light ${styles.contactus_roottext}`}>You can contact MYLO via our <a href={"tel:+136956"}>13 69 56</a> number 24/7, Monday to Friday, ensuring prompt assistance and support during all hours.<br/><br/>Our dedicated team is available to handle enquiries, provide guidance, and resolve any issues<br/>efficiently. Outside of these operating hours, we understand that urgent matters can arise. For<br/>such emergencies, please contact our designated emergency number.<br/><br/>This line is monitoried 24/7 to ensure that critical issues are addressed without delay.<br/>We are committed to maintaining a high standard of service at all times, with reliable support<br/>available both during the day and in emergency sitations after hours.</p>

				<div className={styles.mylo_hq}>
					<button className={`${styles.mylo_hq_btn} ${activeMap === "VIC" && styles.active_mylo_hq_btn}`} onClick={() => handleMap("VIC")}>
						<p className={`m3 forma bold`}>Victoria</p>
						<p className={`m1 inter light`}>Level 1, 469-479 Glen Huntly Road<br/>Elsternwick VIC 3185</p>
					</button>

					<button className={`${styles.mylo_hq_btn} ${activeMap === "NSW" && styles.active_mylo_hq_btn}`} onClick={() => handleMap("NSW")}>
						<p className={`m3 forma bold`}>New South Wales</p>
						<p className={`m1 inter light`}>Tower 2, 1705/101 Grafton St<br/>Bondi Junction NSW 2022</p>
					</button>

					<div className={styles.map_container}><div id="map"></div></div>
				</div>

			</div>
		</div>
	)
}


const Contact = () => {
	usePageMetadata({
		title: "MYLO | Contact",
		description: "Have questions or need assistance? Get in touch with the MYLO team—fill out our online form, send us an email, or give us a call for expert support on Home, Safety, Tradies, and Home Modifications services. We’re here to help!"
	});

	const containerRef = useRef(null);

	useEffect(() => {
  	const container = containerRef.current;
  	if (!container) return;

  	const children = Array.from(container.children);
  	const observer = new IntersectionObserver((entries, obs) => {
    		entries.forEach(entry => {
      		if (entry.isIntersecting) {
        			entry.target.classList.add(styles.isVisible);
        			obs.unobserve(entry.target);
      		}
    		});
  	}, { threshold: 0.1 });

  	children.forEach(el => {
    		el.classList.add(styles.fadeInSection);
    		observer.observe(el);
  	});

  	return () => observer.disconnect();
  }, []);


	return (
		<div className={styles.background} ref={containerRef}>
			<Topbar active={"Contact"}/>
			<Banner/>
			<ContactUsBoxes/>
			<HouseBanner/>
			<ContactUsModule/>

			<Footer/>
		</div>
	)
};

export default Contact;